import { baseApi } from "@/redux/api/baseApi";

export const divisionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDivisions: builder.query({
      query: () => ({
        url: "/divisions",
        method: "GET",
      }),
    }),
    getServices: builder.query({
      query: ({
        division_id,
        is_active,
      }: {
        division_id?: string;
        is_active?: boolean;
      }) => ({
        url: "/services",
        method: "GET",
        params: {
          ...(division_id && { division_id }),
          ...(is_active !== undefined && { is_active }),
        },
      }),
    }),
    getAllServices: builder.query({
      query: () => ({
        url: "/services",
        method: "GET",
      }),
    }),
    calculateLogistics: builder.mutation({
      query: ({ delivery_address }: { delivery_address: string }) => ({
        url: "/public-appointments/calculate-logistics",
        method: "POST",
        body: { delivery_address },
      }),
    }),
    uploadNdisCertificate: builder.mutation({
      query: ({
        appointmentId,
        file,
      }: {
        appointmentId: string;
        file: File;
      }) => {
        const formData = new FormData();
        formData.append("certificate", file);
        return {
          url: `/public-appointments/${appointmentId}/ndis-certificate`,
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useGetDivisionsQuery,
  useGetServicesQuery,
  useCalculateLogisticsMutation,
  useUploadNdisCertificateMutation,
  useGetAllServicesQuery,
} = divisionsApi;
